import { cva, type VariantProps } from 'class-variance-authority';

export const pinInputVariants = cva(
	'h-9xl w-9xl rounded-medium shadow-xs flex items-center justify-center border text-center text-lg font-semibold focus-within:ring-4 focus-within:ring-opacity-15 focus-within:ring-offset-0 focus-visible:outline-0 disabled:bg-gray-100 disabled:text-gray-500',
	{
		variants: {
			hasError: {
				true: 'border-error-300 focus-within:ring-error-500 [&_svg]:fill-error-500',
				false: 'border-gray-300 focus-within:ring-gray-400',
			},
		},
	},
);

export type PinInputVariants = VariantProps<typeof pinInputVariants>;

export { default as PinInput } from './PinInput.vue';
export { default as PinInputGroup } from './PinInputGroup.vue';
export { default as PinInputInput } from './PinInputInput.vue';
export { default as PinInputSeparator } from './PinInputSeparator.vue';
